<template>
  <p class="password-field">
    <input type="password" class="password-field__input"
           :required="data.required"
           v-validate="data.validationRule"
           :class="{'input': true, 'is-danger': errors.has(data.id) }"
           :id="data.id"
           :name="data.id"
           :placeholder="data.placeholder">
    <span v-show="errors.has(data.id)" class="mail-field__error-message">{{ errors.first(data.id) }}</span>
    <label class="password-field__label" :for="data.id">
      {{data.label}}
    </label>

  </p>
</template>

<script>
export default {
  name: 'PasswordField',
  props: {
    data: Object
  }
}
</script>

<style lang="scss">
  .password-field {
    position: relative;
    display: flex;
    margin: 0;
    max-width: 390px;
    justify-content: flex-end;
    align-items: center;

    &__input {
      display: block;
      width: 300px;
      padding: 12px 12px 9px 7.5px;
      letter-spacing: 0.3px;
      border: 1px solid #ebedf2;
      border-radius: 3px;
      transition: 250ms ease-in;
      box-sizing: border-box;

      &:focus {
        outline: 0;
        border-color: #554dbd;
      }

      ::placeholder {
        opacity: 1;
        color: #999999;
      }
    }

    &__label {
      order: -1;
      margin-top: 1px;
      margin-right: 20px;
      font-size: 14px;
      line-height: 21px;
      color: #333333;
    }
  }
</style>
